"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import { useState, useMemo, useEffect } from "react";
import { Box } from "@mui/material";
import { Checkbox } from "@nxt-costco-com/forge-components";
import { useLocalStorage } from "../../../hooks/useLocalStorage/index.js";
import { COMPARE_PRODUCTS_LOCAL_STORAGE_KEY } from "./constants.js";
import { StyledLabel } from "./styles.js";
const COMPONENT_NAME = "CompareProductCheckbox";
const CompareProductCheckbox = ({
  showCompareProductButton = false,
  isFsaEligible = false,
  isChdiEligible = false,
  partNumber,
  productName,
  productImageUrl,
  label = "Compare Product",
  productTitleId
}) => {
  const [compareProductsState, setCompareProductsState] = useLocalStorage(
    COMPARE_PRODUCTS_LOCAL_STORAGE_KEY,
    []
  );
  const [isChecked, setIsChecked] = useState(false);
  const memoizedCompareProductsState = useMemo(
    () => compareProductsState,
    [compareProductsState]
  );
  useEffect(() => {
    const checkIfSelected = memoizedCompareProductsState.some(
      (item) => item.partNumber === partNumber
    );
    setIsChecked(checkIfSelected);
  }, [memoizedCompareProductsState, partNumber]);
  if (!showCompareProductButton) return null;
  const onChange = (_, checked) => {
    if (checked) {
      const newProductToCompare = {
        alt: productName,
        compareImage: productImageUrl,
        isFsaOrChd: Boolean(isFsaEligible || isChdiEligible),
        partNumber
      };
      setCompareProductsState((prev) => [
        ...prev,
        newProductToCompare
      ]);
    } else {
      setCompareProductsState(
        (prev) => prev.filter(
          (item) => item.partNumber !== partNumber
        )
      );
    }
  };
  return /* @__PURE__ */ jsxs(Box, { children: [
    /* @__PURE__ */ jsx(
      Checkbox,
      {
        ariaDescribeText: productTitleId,
        id: `${COMPONENT_NAME}-${partNumber}`,
        isChecked,
        onChange
      }
    ),
    /* @__PURE__ */ jsx(StyledLabel, { htmlFor: `${COMPONENT_NAME}-${partNumber}`, children: label })
  ] });
};
CompareProductCheckbox.displayName = COMPONENT_NAME;
export {
  CompareProductCheckbox
};
